import { Image } from "./style";

const ImageComponent = (props) => {
    return ( 
        <Image src={props.image} />
     );
}
 
export default ImageComponent;